'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = (0, _components2.default)({
  is: 'input',
  type: 'range',
  width: 1,
  mx: 0,
  my: 2,
  color: 'inherit',
  bg: 'gray',
  borderRadius: 99999
}, 'width', 'space', 'color', 'borderRadius', function (props) {
  return {
    display: 'block',
    height: '4px',
    cursor: 'pointer',
    appearance: 'none',
    '&::-webkit-slider-thumb': {
      width: '16px',
      height: '16px',
      backgroundColor: 'currentcolor',
      border: 0,
      borderRadius: '99999px',
      appearance: 'none'
    }
  };
});

Slider.displayName = 'Slider';

exports.default = Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rebass/dist/Slider.js
// module id = 105
// module chunks = 4